import 'smoothstate/src/jquery.smoothState'

export default (function(window, document, undefined) {

  var $html = $('html, body');

  /**
   * Page Transitions
   * @param  {element}   $wrapper
   * @param  {object}    transitions  { 'name': ($container, $newContent) => promise }
   * @param  {function}  onStart
   * @param  {function}  onComplete
   * @param  {object}    params
   * @constructor
   */
  function PageTransitions($wrapper, transitions, onStart, onComplete, params) {

    // Defaults
    onStart = (typeof onStart === 'function') ? onStart : () => {};
    onComplete = (typeof onComplete === 'function') ? onComplete : () => {};
    this.params = {
      debug: true,
      blacklist: '.no-pjax',
      prefetch: true,
      cacheLength: 2,
      locationHeader: 'x-pjax-url',
      scroll: false, // If you want to use the default scroll handler, set to true
      alterRequest: (request) => request,
      ...params
    };

    // If prefetch is enabled, allow specified links to be disabled
    if (this.params.prefetch) {
      this.params.prefetchOn = 'prefetch';

      $('a:not(.no-prefetch)').on('mouseover touchstart', function(event) {
        $(this).trigger('prefetch');
      });
    }

    // Check for custom transitions
    this.params.onBefore = ($el, $container) => {

      this.$trigger = $el;

      let key = $el.attr('data-transition');

      if (key) {
        $('.m-scene').attr('data-transition', key);
      }
    };

    // Skip start event. Go straight to ready
    // Note: Could include a loading animation here
    this.params.onStart = {
      duration: this.params.hasOwnProperty('onStartDuration') ? this.params.onStartDuration : 0,
      render: onStart
    };

    // Handle entire transition in ready event
    this.params.onReady = {
      duration: 0,
      render: ($container, $newContent) => {
        let $oldScene = $('.m-scene:not(.is-exiting)');
        let key = $oldScene.attr('data-transition');

        // If key isn't found, default to first transition
        if (!transitions[key]) {
          key = Object.keys(transitions)[0];
        }

        transitions[key]($container, $newContent).then(onComplete);
      }
    };

    // Init smoothState.js
    this.smoothState = $wrapper.smoothState(this.params).data('smoothState');
  }



  // ------------------------------
  // Public
  // ------------------------------

  return {
    init: function(params) {
      return window.pageTransitions = new PageTransitions(
        params.$wrapper,
        params.transitions,
        params.onStart,
        params.onComplete,
        params.options
      );
    }
  };

})(window, document);
